import React, { useEffect } from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import styles from "./TermsOfUse.module.css";

const TermsOfUse = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.pageContainer}>
      <Navbar />

      <div className={styles.contentWrapper}>
        <h1 className={styles.title}>Terms of Use</h1>
        <p className={styles.lastUpdated}>Last updated: January 4, 2026</p>

        <div className={styles.section}>
          <p>
            Welcome to Dukamo Coffee. By accessing or using our website, you
            agree to be bound by these Terms of Use and our Privacy Policy. If
            you do not agree to these terms, please do not use our services.
          </p>
        </div>

        <div className={styles.section}>
          <h2>1. Use of Our Service</h2>
          <p>
            You agree to use our website only for lawful purposes. You must not
            use our site to transmit any malicious code, interfere with our
            service's performance, or violate any local laws in Ethiopia or your
            jurisdiction.
          </p>
        </div>

        <div className={styles.section}>
          <h2>2. Products and Pricing</h2>
          <p>
            We strive to display our products and prices accurately. However,
            Dukamo Coffee reserves the right to correct any errors in pricing or
            product descriptions and to cancel orders arising from such errors.
            Prices are denominated in Ethiopian Birr (ETB) unless otherwise
            stated.
          </p>
        </div>

        <div className={styles.section}>
          <h2>3. Intellectual Property</h2>
          <p>
            All content on this website, including text, graphics, logos,
            images, and software, is the property of Dukamo Coffee or its
            content suppliers and is protected by international copyright laws.
          </p>
        </div>

        <div className={styles.section}>
          <h2>4. Limitation of Liability</h2>
          <p>
            Dukamo Coffee shall not be liable for any indirect, incidental,
            special, or consequential damages resulting from your use of—or
            inability to use—the website or our products.
          </p>
        </div>

        <div className={styles.section}>
          <h2>5. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with
            the laws of Ethiopia, without regard to its conflict of law
            provisions.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsOfUse;
